// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"src-components-Shards-VideoPlayer-IGTV-styles-style-module__videoPlayer--3UrsM"};